import { render, staticRenderFns } from "./ResourceGeographicalLayer.vue?vue&type=template&id=dfb6d392&"
import script from "./ResourceGeographicalLayer.vue?vue&type=script&lang=js&"
export * from "./ResourceGeographicalLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports